import { render, staticRenderFns } from "./DirectoryContent.vue?vue&type=template&id=6fd0faa2&scoped=true"
import script from "./DirectoryContent.vue?vue&type=script&lang=ts"
export * from "./DirectoryContent.vue?vue&type=script&lang=ts"
import style0 from "./DirectoryContent.vue?vue&type=style&index=0&id=6fd0faa2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd0faa2",
  null
  
)

export default component.exports